import {axiosWithAuth, deepCase} from '@imt/vue-toolbox/src/utils';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const authedAxios = axiosWithAuth();

export const getters = {};

export const actions = {
    async fetchAllRuleRuns(context, policyVersionId) {
        const response = await authedAxios.get(`/runs/${policyVersionId}/`),
            runs = deepCase(response?.data?.data || [], 'camel', ['extension']);

        context.commit('SET_BRD_DATA', {field: 'runs', data: runs});
    },
    async fetchRulesFromCache(context, policySystemId) {
        const response = await authedAxios.get(`/policy-systems/${policySystemId}/rules/cache/`),
            ruleVersions = deepCase(response?.data?.data || [], 'camel', ['extension']);

        context.commit('SET_BRD_DATA', {field: 'ruleVersions', data: ruleVersions});
    },
};

export const mutations = {
    SET_BRD_DATA(state, {field, data}) {
        state[field] = data;
    },
};

export const state = () => {
    return {
        loading: false,
        selectedRun: null,
        runs: [],
        ruleVersions: [],
    };
};

export default {
    actions,
    mutations,
    getters,
    namespaced: true,
    state: state()
};
